/**
 * @deprecated Use components/ConditionalWrapper.tsx
 */
export default ({ condition, wrapper, children }) =>
  condition ? wrapper(children) : children;
